import React from 'react';
import { Box, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { playAudio } from '../../../Utils/AudioUtils';
import { t } from '../../../i18n';

interface TopUpOptionsComponentProps {
    playerId: string;
    topUpNextHandPlayers: string[] | Set<string> | null | undefined;
    topUpAllHandsPlayers: string[] | Set<string> | null | undefined;
    onTopUpOptionChange: (type: 'next' | 'all' | 'cancel', playerId: string) => void;
    isSatOut?: boolean;
    willSitOutNextHand?: boolean;
}

const TopUpOptionsComponent: React.FC<TopUpOptionsComponentProps> = ({
    playerId,
    topUpNextHandPlayers,
    topUpAllHandsPlayers,
    onTopUpOptionChange,
    isSatOut,
    willSitOutNextHand
}) => {
    if (isSatOut) {
        return null;
    }

    const isInNextHand = topUpNextHandPlayers ? 
        (Array.isArray(topUpNextHandPlayers) 
            ? topUpNextHandPlayers.includes(playerId)
            : topUpNextHandPlayers.has(playerId)) 
        : false;

    const isInAllHands = topUpAllHandsPlayers ? 
        (Array.isArray(topUpAllHandsPlayers) 
            ? topUpAllHandsPlayers.includes(playerId)
            : topUpAllHandsPlayers.has(playerId)) 
        : false;

    const handleNextHandChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            onTopUpOptionChange('next', playerId);
        } else {
            onTopUpOptionChange('cancel', playerId);
        }
        playAudio('pop.mp3');
    };

    const handleAllHandsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            onTopUpOptionChange('all', playerId);
        } else {
            onTopUpOptionChange('cancel', playerId);
        }
        playAudio('pop.mp3');
    };

    return (
        <Box>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={isInNextHand}
                            onChange={handleNextHandChange}
                            disabled={isInAllHands || willSitOutNextHand}
                            sx={{ 
                                color: '#9eb0c5',
                                padding: '5px 9px',
                                '&.Mui-checked': {
                                    color: '#ffffff'
                                }
                            }}
                        />
                    }
                    label={t('GameRoom:topUpOptions.topUpNextHand')}
                    sx={{ 
                        color: '#fff',
                        '& .MuiFormControlLabel-label': {
                            fontSize: '12px',
                            fontFamily: '"Inter", serif',
                            fontWeight: 600
                        }
                    }}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={isInAllHands}
                            onChange={handleAllHandsChange}
                            disabled={isInNextHand || willSitOutNextHand}
                            sx={{ 
                                color: '#9eb0c5',
                                padding: '5px 9px',
                                '&.Mui-checked': {
                                    color: '#ffffff'
                                }
                            }}
                        />
                    }
                    label={t('GameRoom:topUpOptions.topUpAllHands')}
                    sx={{ 
                        color: '#fff',
                        '& .MuiFormControlLabel-label': {
                            fontSize: '12px',
                            fontFamily: '"Inter", serif',
                            fontWeight: 600
                        }
                    }}
                />
            </FormGroup>
        </Box>
    );
};

export default TopUpOptionsComponent;